<script>
export default {
  name: 'AppStoreBadgesItem',
  props: {
    linkLocation: {
      type: String,
      default: 'default',
      validator: value => {
        return ['hero', 'footer', 'push-modal', 'default'].includes(value)
      }
    }
  },
  data() {
    return {
      badges: [
        {
          type: 'apple',
          alt: 'Get Thriva on the App store',
          event: 'appleStoreBadgeClicked'
        },
        {
          type: 'google',
          alt: 'Get Thriva on Google Play',
          event: 'playStoreBadgeClicked'
        }
      ]
    }
  },
  methods: {
    onBadgeClick(event, link) {
      this.$emit(event, { link })
    },
    getHeroLinkByType(type) {
      return type === 'apple'
        ? 'https://thriva.onelink.me/lvy7/5f490462'
        : 'https://thriva.onelink.me/lvy7/556f13ba'
    },
    getModalLinkByType(type) {
      return type === 'apple'
        ? 'https://thriva.onelink.me/lvy7/e604d43a'
        : 'https://thriva.onelink.me/lvy7/3cedb24'
    },
    setHref(type) {
      switch (this.linkLocation) {
        case 'hero':
          return this.getHeroLinkByType(type)
        case 'footer':
          return 'https://thriva.onelink.me/lvy7/285b1945'
        case 'push-modal':
          return this.getModalLinkByType(type)
        default:
          return 'https://thriva.onelink.me/lvy7/4f323146'
      }
    }
  }
}
</script>

<template lang="pug">
.app-store-badges-item
  a(
    v-for='(badge, i) in badges'
    :key='i'
    :href='setHref(badge.type)'
    target='_blank'
    @click='onBadgeClick(badge.event, setHref(badge.type))'
  )
    img(
      v-if='badge.type === "apple"'
      src='../../assets/images/icons/app-store-link.svg'
      :alt='badge.alt'
    )
    img(
      v-else
      src='../../assets/images/icons/play-store-link.svg'
      :alt='badge.alt'
    )
</template>

<style lang="stylus" scoped>
@import '../../assets/styles/modules/*'

.app-store-badges-item

  a
    display: inline-block

    &:not(:last-of-type)
      margin: 0 10px 10px 0

  img
    height: 40px
    width: 132px
</style>
